// Catalogo de servicios que se muestran como "disponibles para agregar".
//
// Son solo informativos: aparecen en gris con un candado y, al pulsarlos, sale
// el mismo aviso de "contacta al administrador". NO se pueden abrir ni se
// activan solos: para que un cliente los use de verdad hay que darlos de alta
// en la base de datos como las demas aplicaciones.
//
// Las imagenes van en frontend/public/img/ con exactamente estos nombres.
// Si un archivo no esta, la tarjeta muestra las iniciales en su lugar.
//
// OJO con las iniciales: la tarjeta no muestra el titulo debajo, asi que si
// falta la imagen quedan varias iguales (Insite e Incal darian las dos "IN").
// Por eso cada programa de diesel lleva su rotulo, con el nombre y la version
// dentro del propio cuadro.
//
// Son DOS listas porque en pantalla van bajo dos titulos distintos:
// "Available to add" y "Heavy Duty Software".

// ---------------------------------------------------------------------------
// Diagnostico general
// ---------------------------------------------------------------------------
exports.catalog = [  {
    key: "ford-ids",
    tittle: "Ford IDS",
    description: "Integrated Diagnostic System",
    img: "/img/ford-ids.jpg",
  },
  {
    key: "mitchell-ultramate",
    tittle: "Mitchell UltraMate",
    description: "Estimating for collision repair",
    img: "/img/mitchell-ultramate.jpg",
  },
  {
    key: "mitchell1-truckseries",
    tittle: "Mitchell 1 TruckSeries",
    description: "Repair information for commercial trucks",
    img: "/img/mitchell1-truckseries.jpg",
  },
  {
    key: "mitchell1-prodemand",
    tittle: "Mitchell 1 ProDemand",
    description: "Repair, estimating and maintenance",
    img: "/img/mitchell1-prodemand.jpg",
  },
  {
    key: "mitchell-enlyte",
    tittle: "Mitchell",
    description: "An Enlyte company",
    img: "/img/mitchell-enlyte.png",
  },
];

// ---------------------------------------------------------------------------
// Vehiculo pesado (diesel)
// ---------------------------------------------------------------------------
exports.heavyDuty = [
  {
    key: "insite",
    tittle: "Cummins INSITE 9.3",
    description: "Engine diagnostics for Cummins",
    img: "/img/insite.svg",
  },
  {
    key: "calterm",
    tittle: "Cummins Calterm 5.16",
    description: "Calibration and parameter editing",
    img: "/img/calterm.svg",
  },
  {
    key: "incal",
    tittle: "Cummins INCAL 9.1",
    description: "Calibration files for Cummins engines",
    img: "/img/incal.svg",
  },
  {
    key: "dddl",
    tittle: "Detroit DDDL 8.22",
    description: "Detroit Diesel Diagnostic Link",
    img: "/img/dddl.svg",
  },
  {
    key: "jpro",
    tittle: "JPRO 2026",
    description: "Commercial fleet diagnostics",
    img: "/img/jpro.svg",
  },
  {
    key: "etech-214",
    tittle: "Mack E-Tech 2.14",
    description: "Diagnostics for Mack engines",
    img: "/img/etech-214.svg",
  },
  {
    key: "etech-215",
    tittle: "Mack E-Tech 2.15",
    description: "Diagnostics for Mack engines",
    img: "/img/etech-215.svg",
  },
  {
    key: "service-ranger",
    tittle: "Eaton ServiceRanger 4.13",
    description: "Transmission diagnostics",
    img: "/img/service-ranger.svg",
  },
  {
    key: "hino-dx2",
    tittle: "Hino DX 2",
    description: "Diagnostics for Hino trucks",
    img: "/img/hino-dx2.svg",
  },
  {
    key: "hino-dx3",
    tittle: "Hino DX 3",
    description: "Diagnostics for Hino trucks",
    img: "/img/hino-dx3.svg",
  },
  {
    key: "ned",
    tittle: "NED 2025",
    description: "Navistar engine diagnostics",
    img: "/img/ned.svg",
  },
  {
    key: "dlb",
    tittle: "DLB 2025",
    description: "Diamond Logic Builder",
    img: "/img/dlb.svg",
  },
  {
    key: "sds",
    tittle: "SDS 2025",
    description: "Service diagnostic software",
    img: "/img/sds.svg",
  },
  {
    key: "allison",
    tittle: "Allison DOC 2024",
    description: "Transmission diagnostics",
    img: "/img/allison.svg",
  },
  {
    key: "bendix",
    tittle: "Bendix ACom 2024",
    description: "Brake system diagnostics",
    img: "/img/bendix.svg",
  },
];
